import script from "./BannerTempThree.vue?vue&type=script&setup=true&lang=js"
export * from "./BannerTempThree.vue?vue&type=script&setup=true&lang=js"

import "./BannerTempThree.vue?vue&type=style&index=0&id=695267e5&lang=scss&scoped=true"
import "./BannerTempThree.vue?vue&type=style&index=1&id=695267e5&lang=scss"

import exportComponent from "F:\\ubuntuBK\\sombardc\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-695267e5"]])

export default __exports__